/**
 * @generated SignedSource<<cf1dbbec5a93f401c1521e81fe571beb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type FileIcon_File$data = {
  readonly isOrg: boolean;
  readonly type: FileType | null;
  readonly " $fragmentType": "FileIcon_File";
};
export type FileIcon_File$key = {
  readonly " $data"?: FileIcon_File$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileIcon_File">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileIcon_File",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "e44b69173ab9b5b30ec541b7e0800aa3";

export default node;
